import { render, staticRenderFns } from "./customTooltip.vue?vue&type=template&id=2fb10f63"
import script from "./customTooltip.vue?vue&type=script&lang=js"
export * from "./customTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports